import store from '@/store/store';
import { TYPE_HOLDING } from '@/configuration/societe/societe';

export function siteHasHolding() {
  const societes = store.getters['societe/societesInformations'];

  const holding = societes.find((societe) => {
    return societe.typeSociete === TYPE_HOLDING;
  });

  return holding !== undefined;
}

export function getIdSocieteHolding() {
  const societes = store.getters['societe/societesInformations'];

  const holding = societes.find((societe) => {
    return societe.typeSociete === TYPE_HOLDING;
  });

  return holding ? holding.id : null;
}
